<template>
  <div class="juniorToSenior">
    <main>
      <div class="module1">
        <div class="container">
          <div class="left">
            <h3>2023年新高一学生 <br> 暑期学习计划</h3>
          </div>
          <div class="right">
            <div class="img">
              <img src="../../assets/img/chushenggao/csg_banner3.png" alt="">
            </div>
          </div>
        </div>
      </div>
      <div class="module2">
        <div class="container">
          <div class="title">新生入学测评</div>
          <div class="list">
            <div
              class="box"
              v-for="(item,index) in appraisalList"
              :key="index"
              @click="jumpUrl('/careerplanningDashboard/careerassessmentUp/CareerassessmentUpReminder?name='+item.link)">
              <div class="img">
                <img :src="item.icon" alt="">
              </div>
              <p>{{item.name}}</p>
            </div>
          </div>
        </div>
      </div>
      <div class="module3">
        <div class="container">
          <div class="title">生涯规划指导</div>
          <div class="titleList">
            <button
              v-for="(item,index) in guideList"
              :key="index"
              :class="item.categoryName===guide.categoryName?'active':''"
              @click="checkGuide(item)">
              <span>{{item.categoryName}}</span>
            </button>
          </div>
          <div class="content">
            <div class="contentListBox">
              <div
                class="box"
                v-for="(itemC,indexC) in guide.children"
                :key="indexC"
                @click="jumpVideo(itemC.videoId)">
                <div class="img">
                  <img :src="itemC.pic" alt="">
                </div>
                <div class="info">
                  <div class="title">{{itemC.title}}</div>
                  <p>
                    <span class="type">{{guide.categoryName}}</span>
                    <i>{{itemC.createdTime}}</i>
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="moreBox">
            <button
              @click="jumpUrl('/stu/career-lession')">
              <span>查看更多</span>
            </button>
          </div>
        </div>
      </div>
      <div class="module4">
        <div class="container">
          <div class="title">开学考试</div>
          <div class="subjectList">
            <button
              v-for="(item,index) in subjectList"
              :key="index"
              :class="item.id===subject.id?'active':''"
              @click="checkSubject(item)">
              <span>{{item.subjectName}}</span>
            </button>
          </div>
          <div class="content">
            <div class="contentListBox">
              <div
                class="box"
                v-for="(sub,subIndex) in subject.children"
                v-show="isMoreShow?subIndex<=5:subIndex>=0"
                :key="subIndex">
                <div class="left">
                  <div class="img">
                    <img src="../../assets/img/chushenggao/pdf.png" alt="">
<!--                    <img v-if="sub.type === 1" src="../../assets/img/chushenggao/word.png" alt="">-->
                  </div>
                  <div class="info">
                    <div class="title">{{sub.name}}</div>
                    <p>
                      <span class="updateDate">更新日期：{{sub.createdAt}}</span>
                      <span class="browseNum">浏览次数：{{sub.viewTimes}}</span>
                      <span class="downloadNum">下载次数：{{sub.downTimes}}</span>
                    </p>
                  </div>
                </div>
                <div class="right">
                  <el-button type="text" @click="jumpTestDetail(sub.id)">预览</el-button>
                  <el-button type="text" @click="downLoadTest(sub)">下载</el-button>
                </div>
              </div>
            </div>
            <div class="moreBox">
              <button
                v-show="isMoreShow"
                @click="checkMore">
                <i class="el-icon-arrow-down"></i>
                <span>显示更多</span>
              </button>
              <button
                v-show="!isMoreShow"
                @click="checkLess">
                <i class="el-icon-arrow-up"></i>
                <span>收起更多</span>
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="module5">
        <div class="container">
          <div class="title">提前学习18天</div>
          <div class="dayList">
            <button
              v-for="day in 18"
              :key="day"
              :class="day===dayWork.day?'active':''"
              @click="checkDayWork(day)">
              <i>DAY</i>
              <p>{{day}}</p>
            </button>
          </div>
          <div class="content">
            <div class="contentListBox">
              <div
                class="box"
                v-for="(day,dayIndex) in dayWork.list"
                :key="dayIndex"
                @click="jumpVideo(day.albumId)">
                <div class="img">
                  <img :src="day.picture" alt="">
                </div>
                <div class="info">
                  <div class="title">{{day.title}}</div>
                  <p>
                    <span class="duration">(建议时长{{day.durationStr}})</span>
                  </p>
                </div>
              </div>
            </div>
<!--            <div class="btn">-->
<!--              <el-button-->
<!--                size="small"-->
<!--                type="primary">-->
<!--                <span>一键布置</span>-->
<!--              </el-button>-->
<!--            </div>-->
          </div>
        </div>
      </div>
    </main>
    <footer>
      <foot-component />
    </footer>
  </div>
</template>

<script>
  import footComponent from '../../components/foot.vue'
  import { getCareerEvaluate, getCareerVideo, getTest, getHomework, testPaperDownload } from '../../config/index.js'
  export default {
    name: "juniorToSenior",  // 初升高
    data() {
      return {
        imgList: [
          { img: require('../../assets/img/chushenggao/专业倾向测试.png'), i: 0 },
          { img: require('../../assets/img/chushenggao/多元智能测试.png'), i: 1 },
          { img: require('../../assets/img/chushenggao/学习压力测试.png'), i: 2 },
          { img: require('../../assets/img/chushenggao/文理兴趣测试.png'), i: 3 },
          { img: require('../../assets/img/chushenggao/气质类型测试.png'), i: 4 },
          { img: require('../../assets/img/chushenggao/职业性格测试.png'), i: 5 },
        ],
        appraisalList: [],  // 生涯测评列表
        guide: {
          children: []
        },
        guideList: [],  // 生涯规划指导 列表
        subject: {},
        subjectList: [],  // 试题列表
        isMoreShow: true,
        dayWork: {
          day: 1,
          list: []
        },
        homeworkList: [  // 18天作业列表
          // {
            // day: 1,
            // list: []
          // }
        ]
      }
    },
    components: {
      footComponent,
    },
    created() {
      this.getCareerEvaluate();  // 获取生涯测评
      this.getCareerVideo();  // 获取生涯指导视频
      this.getTest();  // 获取试卷
      // 判断是否含有当天作业，如果有则直接获取； 没有先调用接口
      this.judgeHaveHomework();

    },
    methods: {
      // 获取生涯测评
      async getCareerEvaluate() {
        const res = await getCareerEvaluate();
        if(res.status) {
          let data = res.data;
          for(let i=0; i<data.length; i++) {
           this.imgList.forEach(img => {
             if(i === img.i) {
               data[i].icon = img.img
             }
           })
          }
          this.appraisalList = data;
        }
      },
      // 获取生涯指导视频
      async getCareerVideo() {
        const res = await getCareerVideo();
        if(res.status) {
          this.guideList = res.data;
          if(this.guideList.length) {
            this.guide = this.guideList[0];
          }
        }
      },
      // 获取试卷
      async getTest() {
        const res = await getTest();
        if(res.status) {
          this.subjectList = res.data;
          console.log(this.subjectList);
          if(this.subjectList.length) {
            this.subject = this.subjectList[0];
          }
        }
      },
      // 判断是否由当前作业
      judgeHaveHomework() {
        // 先判断作业列表是否为空，再判断作业列表中是否含有当前天的作业
        let length = this.homeworkList.length;
        if(length) {
          let timeOut = 0;
          this.homeworkList.forEach(homework => {
            if(homework.day === this.dayWork.day) {
              timeOut = 1;
              this.dayWork.list = homework.list;
            }
          });
          // 判断timeOut； =0，不含当天作业；=1，含当天作业
          if(!timeOut) {
            this.$loading.show();
            let timer1 = setTimeout(() => {
              this.$loading.hide();
              this.getHomework();  // 获取作业
              clearTimeout(timer1)
            },500)
          }
        }else{
          this.$loading.show();
          let timer2 = setTimeout(() => {
            this.$loading.hide();
            this.getHomework();  // 获取作业
            clearTimeout(timer2)
          },500)
        }

      },
      // 获取作业
      async getHomework() {
        const res = await getHomework({
          day: this.dayWork.day
        });
        if(res.status) {
          let list = res.data;
          this.homeworkList.push({
            day: this.dayWork.day,
            list: list
          });
          this.homeworkList.forEach(item => {
            if(item.day === this.dayWork.day) {
              this.dayWork.list = item.list;
            }
          })
        }
      },
      // 跳转
      jumpUrl(url) {
        this.$loading.show();
        let timer = setTimeout(() => {
          this.$loading.hide();
          window.open(url, '_blank');
          clearTimeout(timer);
        },400)
      },
      // 切换生涯规划指导
      checkGuide(item) {
        console.log(item);
        this.guide = item;
      },
      // 查看视频
      jumpVideo(albumId) {
        let routeData = this.$router.resolve({
          path: '/videoPlayer',
          query: {
            albumId: albumId,
            type: null
          }
        });
        window.open(routeData.href, '_blank')
      },
      // 切换科目
      checkSubject(item) {
        this.subject = item;
        this.isMoreShow = true;
      },
      // 预览试卷
      jumpTestDetail(paperId) {
        console.log(paperId);
        let routeData = this.$router.resolve({
          path: '/schoolPaperSon',
          query: {
            paperId: paperId
          }
        });
        window.open(routeData.href, '_blank')
      },
      // 下载试卷
      downLoadTest(val) {
        this.downloadUp(val);
      },
      //试卷下载
      async downloadUp(val){
        let result=await testPaperDownload(val.id);
        if(result.status){
          let zhi=window.atob(result.data);
          let link = document.createElement("a");
          let body = document.querySelector("body");
          link.href =zhi;
          link.style.display="none";
          body.appendChild(link);
          link.click();
          body.removeChild(link);
        }
      },
      // 展开更多
      checkMore() {
        this.isMoreShow = false;
      },
      // 收起更多
      checkLess() {
        this.isMoreShow = true;
      },
      // 切换日期
      checkDayWork(day) {
        this.dayWork.day = day;
        this.judgeHaveHomework()  // 判断是否有当天作业
      }
    }
  }
</script>

<style scoped lang="scss">
  @import "../../style/common.scss";
  .juniorToSenior {
    .container{
      margin: auto;
      max-width: 1200px;
    }
    .module1{
      padding: 60px 0;
      background: #F6F7FA;
      .container{
        display: flex;
        justify-content: space-between;
        .left{
          h3{
            margin-top: 120px;
            font-size: 40px;
            font-weight: 500;
            color: rgba(27, 28, 50, 0.85);
          }
        }
      }
    }
    .module2{
      padding: 60px 0;
      .title{
        text-align: center;
        margin: 30px 0 50px;
        font-size: 48px;
        font-weight: 400;
        color: rgba(27, 28, 50, 0.85);
      }
      .list{
        display: flex;
        justify-content: space-around;
        .box{
          min-width: 160px;
          text-align: center;
          cursor: pointer;
          transition: all 0.5s;
          padding-top: 10px;
          border: 1px solid #fff;
          .img{
            display: inline-block;
            border: 1px dotted #999;
          }
          p{
            text-align: center;
            margin: 16px 0;
            font-size: 18px;
            font-weight: 400;
            color: #39425E;
          }
        }
        .box:hover{
          border: 1px solid #ddd;
        }
      }
    }
    .module3{
      padding: 60px 0;
      background: #F6F7FA;
      .title{
        text-align: center;
        margin: 30px 0 50px;
        font-size: 48px;
        font-weight: 400;
        color: rgba(27, 28, 50, 0.85);
      }
      .titleList{
        height: 56px;
        border-radius: 2px;
        border: 1px solid #1F72FF;
        button{
          background-color: #f6f7fa;
          border: none;
          height: 100%;
          width: 25%;
          cursor: pointer;
          span{
            font-size: 20px;
            font-weight: 400;
            color: rgba(27, 28, 50, 0.85);
          }
        }
        button:hover{
          background-color: #0060ff;
          span{
            color: #fff;
          }
        }
        button.active{
          background-color: #0060ff;
          span{
            color: #fff;
          }
        }
      }
      .content{
        margin: 20px 0;
        .contentListBox{
          min-height: 500px;
          display: flex;
          flex-wrap: wrap;
          justify-content: space-between;
          align-content: space-between;
          .box{
            width: 30%;
            border: 1px dotted #999;
            margin-bottom: 16px;
            cursor: pointer;
            .img{
              width: 100%;
              img{
                width: 100%;
              }
            }
            .info{
              padding: 8px 14px;
              .title{
                font-size: 16px;
                font-weight: 500;
                color: rgba(27, 28, 50, 0.85);
                margin: 8px 0;
                text-align: left;
              }
              p{
                display: flex;
                justify-content: space-between;
                span,i{
                  font-size: 14px;
                  font-weight: 400;
                  color: rgba(27, 28, 50, 0.45);
                }
              }
            }
          }
          .box:hover{
            border: 1px dotted #2e86ff;
            .info{
              .title{
                color: #2e86ff;
              }
              p{
                span{
                  color: #2e86ff;
                }
              }
            }
          }
        }
      }
      .moreBox{
        text-align: center;
        button{
          background-color: #0060ff;
          border: none;
          padding: 6px 12px;
          cursor: pointer;
          border-radius: 15px;
          span,i{
            color: #fff;
            margin: 0 4px;
          }
        }
      }
    }
    .module4{
      padding: 60px 0;
      .title{
        text-align: center;
        margin: 30px 0 50px;
        font-size: 48px;
        font-weight: 400;
        color: rgba(27, 28, 50, 0.85);
      }
      .subjectList{
        border-radius: 2px;
        border: 1px solid #1F72FF;
        height: 56px;
        width: 1199px;
        margin: auto;
        button{
          background-color: #fff;
          border: none;
          height: 100%;
          width: 133px;
          cursor: pointer;
          span{
            font-size: 20px;
            font-weight: 500;
            color: rgba(27, 28, 50, 0.85);
          }
        }
        button:hover{
          background-color: #0060ff;
          span{
            color: #fff;
          }
        }
        button.active{
          background-color: #0060ff;
          span{
            color: #fff;
          }
        }
      }
      .content{
        .contentListBox{
          .box{
            background: #F6F7FA;
            border-radius: 2px;
            display: flex;
            justify-content: space-between;
            padding: 16px;
            margin: 16px 0;
            .left{
              display: flex;
              .img{
                margin-right: 16px;
                img{
                  border: 1px dotted #999;
                }
              }
              .info{
                margin-top: 4px;
                .title{
                  font-size: 14px;
                  font-weight: 600;
                  color: #000000;
                  margin: 0;
                }
                p{
                  margin-top: 4px;
                  span{
                    font-size: 13px;
                    font-weight: 400;
                    color: #999;
                    margin-right: 6px;
                  }
                }
              }
            }
            .right{
              button{
                margin: 0 10px;
                color: #0060ff;
              }
            }
          }
          .box:hover{
            .left{
              .info{
                .title{
                  color: #0060ff;
                }
              }
              p{
                span{
                  color: #0060ff;
                }
              }
            }
          }
        }
        .moreBox{
          text-align: center;
          button{
            background-color: #0060ff;
            border: none;
            padding: 6px 12px;
            cursor: pointer;
            border-radius: 15px;
            span,i{
              color: #fff;
              margin: 0 4px;
            }
          }
        }
      }
    }
    .module5{
      padding: 60px 0;
      background: #F6F7FA;
      .title{
        text-align: center;
        margin: 30px 0 50px;
        font-size: 48px;
        font-weight: 400;
        color: rgba(27, 28, 50, 0.85);
      }
      .dayList{
        display: flex;
        justify-content: space-between;
        button{
          background: #FFFFFF;
          box-shadow: 0 4px 8px 0 rgba(25, 42, 71, 0.1);
          border-radius: 4px;
          border: none;
          padding: 14px 12px;
          cursor: pointer;
          i{
            font-size: 14px;
            font-weight: 400;
            color: #878789;
          }
          p{
            font-size: 36px;
            font-weight: 400;
            color: #242425;
            line-height: 50px;
          }
        }
        button:hover{
          background-color: #0060ff;
          i,p{
            color: #fff;
          }
        }
        button.active{
          background-color: #0060ff;
          i,p{
            color: #fff;
          }
        }
      }
      .content{
        margin: 20px 0;
        .contentListBox{
          .box{
            border: 1px dotted #888;
            display: flex;
            margin: 16px 0;
            background-color: #fff;
            cursor: pointer;
            .img{
              margin-right: 36px;
              width: 290px;
              overflow: hidden;
              img{
                height: 100%;
                width: 100%;
              }
            }
            .info{
              .title{
                font-size: 16px;
                font-weight: 600;
                color: rgba(27, 28, 50, 0.85);
                margin: 26px 0 8px;
                text-align: left;
              }
              p{
                span{
                  font-size: 13px;
                  font-weight: 400;
                  color: rgba(27, 28, 50, 0.45);
                }
              }
            }
          }
          .box:hover{
            border: 1px dotted #0060ff;
            .info{
              .title{
                color: #0060ff;
              }
              p{
                span{
                  color: #0060ff;
                }
              }
            }
          }
        }
        .btn{
          .el-button{
            background-color: #0060ff;
            width: 100%;
            span{
              font-size: 18px;
            }
          }
        }
      }
    }
  }
</style>
